import React, { useEffect, useState } from "react";
import {
  Menu,
  MenuItem,
  Grid,
  makeStyles,
  withStyles,
  Typography,
  Button
} from "@material-ui/core";
import { useSelector } from "react-redux";
import { Skeleton } from "@material-ui/lab";
import PhoneIcon from "@material-ui/icons/Phone";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ListItemText from "@material-ui/core/ListItemText";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { getAssetUrl } from "../../e_home_component/e_account_summary/model/service";
const useStyle = makeStyles((theme) => ({
  heading: {
    backgroundColor: theme.palette.eSecondary?.base,
    color: theme.palette.eWhite?.base,
    padding: "1.5% 3%",
    height: "2.8rem",
    width: "100%",
  },
  mainGrid: {
    flexFlow: "column",
    height: "100%",
  },
  seperationGrid: {
    height: "0.2rem",
    width: "100%",
  },
  contentGrid: {
    flexGrow: "1",
    backgroundColor: theme.palette.ePrimary?.base,
    flexFlow: "column",
  },
  description: {
    color: theme.palette.eWhite?.base,
    paddingBottom: "1rem",
    width: "13.125rem",
    textAlign: "center"
  },
  showNumbersText: {
    flexGrow: "1"
  },
  colorsbutton: {
    width: "100%",
    flexFlow: "row",
    cursor: "pointer",
    padding: "5px",
    borderRadius: "3px"
  },
  phoneIconColor: {
    color: theme.palette.eSecondary?.base,
  },
  styledMenuItemClass: {
    justifyContent: "flex-start !important",
    backgroundColor: theme.palette.eWhite?.base,
    color: theme.palette.ePrimary?.base,
  },
  buttonContainer: {
    border: `0.75rem solid ${theme.palette.eSecondary?.base}`,
    borderRadius: "none",
    backgroundColor: theme.palette.eWhite?.base,
    color: theme.palette.ePrimary?.base,
    width: "13.125rem"
  }
}));

const StyledMenu = withStyles((theme) => ({
  paper: {
    backgroundColor: theme.palette.eWhite?.base,
    color: theme.palette.eWhite?.base,
    border: `1px solid ${theme.palette.ePrimary?.base}`
  },
}))((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));
const StyledMenuItem = withStyles((theme) => ({
  root: {
    "&:focus": {
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {},
    },
  },
  color: theme.palette.ePrimary?.base + "!important",
}))(MenuItem);

const ListMenuItem = withStyles((theme) => ({
  root: {
    "& .MuiListItemText-primary": {
      color: theme.palette.ePrimary?.base + "!important",
    },
    "& .MuiListItemText-secondary": {
      color: theme.palette.ePrimary?.base + "!important",
    },
  },
}))(ListItemText);

function SelfHelpCallus() {
  const [description, setDescription] = useState();
  const [multipleNo, setMultipleNo] = useState([]);
  const [multipleLocation, setMultipleLocation] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [callOne,setCallOne]=useState()
  const [callTwo,setCallTwo]=useState()

  const classes = useStyle();
  const {t:content, ready: contentReady}=useTranslation("content-E_SELF_HELP")
  const {t:labels, ready: labelReady}=useTranslation("label-E_SELF_HELP")
  const {t:contents, ready: contentsReady}=useTranslation("content-E_SELF_HELP")
  const phnNumber = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.SUPPORT_CALL_PHONE_NUMBER
  );

  const callusOne = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.E_CALLUS_ONE
  );

  const callusTwo = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.E_CALLUS_TWO
  );

 
useEffect(()=>{

  if(callusOne){
    getAssetUrl(callusOne).then(res=>{
      if(res?.assetPath){
        setCallOne(res?.assetPath)
      }
    }
    )
  }
  if(callusTwo){
    getAssetUrl(callusTwo).then(res=>{
      if(res?.assetPath){
        setCallTwo(res?.assetPath)
      }
    }
    )
  }

},[callusOne,callusTwo])



  const phnLocation = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.SUPPORT_CALL_PHONE_LOCATION
  );
  const multiple = phnNumber?.includes(",");
  useEffect(() => {
    if (phnLocation && multipleLocation.length === 0) {
      setMultipleLocation(phnLocation.split(","));
    }
    if (multiple === true && multipleNo.length === 0) {
      setMultipleNo(phnNumber.split(","));
    }
  }, [phnNumber, phnLocation]);
  useEffect(() => {
   setDescription(content("E_SELF_HELP_CALL_US_DESCRIPTION")?.answer)
  }, [content,contentReady,i18next]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  let phones = phnNumber?.split(",")
  return (
    <Grid container className={classes.mainGrid}>
      <Grid item container alignItems="center" className={classes.heading}>
      {
        labelReady ? 
        <Typography variant="h6">{labels("E_SELF_HELP_CALL_US")}</Typography> : <Skeleton />
      }
      </Grid>
      <Grid className={classes.seperationGrid}></Grid>
      <Grid
        item
        container
        alignItems="center"
        justify="center"
        className={classes.contentGrid}
      >
        {description ? (
          <Typography
            variant="body2"
            dangerouslySetInnerHTML={{
              __html: description,
            }}
            className={classes.description}
          />
        ) : (
          <Skeleton variant="rectangular" animation="wave" />
        )}
        <Grid
          item
          container
          justify="center"
          alignItems="center"
        >
          <Grid item>
          <a href={`tel:${phones[0]}`} className={classes.aStyles}>
          <Button>
            <img style={{backgroundColor:'white'}} src={callTwo} alt={labels("E_CALLUS_ONE_FALLBACK")}/>
            </Button>
          </a>
          </Grid>
          <Grid item>
          <a href={`tel:${phones[1]}`}  className={classes.aStyles}>
            <Button >
              <img src={callOne} alt={labels("E_CALLUS_TWO_FALLBACK")} />
            </Button>
          </a>
          </Grid>
            {/* <Grid
              item
              xs={12}
              className={[classes.height10, classes.showNumbers].join(" ")}
            >
              {!multiple ? (
                <Grid align="center" className={classes.colorsbutton}>
                  <div style={{ alignItems: "center" }}>
                    <a href={`tel:${phnNumber}`} className={classes.aStyles}>
                      <Button
                        type="submit"
                        variant="outlined"
                        size="Large"
                        align="center"
                        className={classes.phoneIconColor}
                      >
                        <PhoneIcon className={classes.phoneIconColor} />
                        &nbsp;&nbsp;&nbsp;{phnNumber}
                      </Button>
                    </a>
                  </div>
                </Grid>
              ) : (
                <Grid align="center">
                  <div style={{ alignItems: "center" }}>
                    <Button
                      className={classes.colorsbutton}
                      aria-controls="customized-menu"
                      aria-haspopup="true"
                      variant="outlined"
                      color="primary"
                      align="center"
                      onClick={handleClick}
                      startIcon={
                        <PhoneIcon className={classes.phoneIconColor} />
                      }
                      endIcon={<ExpandMoreIcon />}
                    >
                      {labelReady ? labels("E_SELF_HELP_SHOW_NUMBERS") : <Skeleton />}
                    </Button>
                    <StyledMenu
                      id="customized-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                    >
                      {multipleNo.map((item, index) => (
                        <StyledMenuItem className={classes.styledMenuItemClass}>
                          <a
                            href={"tel:" + item}
                            className={classes.linkStyles}
                          >
                            <ListMenuItem
                              primary={item}
                              secondary={
                                multipleLocation[index]
                                  ? multipleLocation[index]
                                  : ""
                              }
                            />
                          </a>
                        </StyledMenuItem>
                      ))}
                    </StyledMenu>
                  </div>
                </Grid>
              )} 
            </Grid> */}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default SelfHelpCallus;
